var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsIconQuestionViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5H2C1.44772 5 1 5.44772 1 6V30C1 30.5523 1.44772 31 2 31H22C22.5523 31 23 30.5523 23 30V6C23 5.44772 22.5523 5 22 5H17",
    stroke: "#9356F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6V4C17 3.44772 16.5523 3 16 3H15C14.4477 3 14 2.55228 14 2C14 1.44772 13.5523 1 13 1H11C10.4477 1 10 1.44772 10 2C10 2.55228 9.55228 3 9 3H8C7.44772 3 7 3.44772 7 4V6C7 6.55228 7.44772 7 8 7H16C16.5523 7 17 6.55228 17 6Z",
    stroke: "#9356F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15L7 17L11 13",
    stroke: "#9356F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22L10 27",
    stroke: "#9356F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 27L10 22",
    stroke: "#9356F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25L19 25",
    stroke: "#9356F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16L19 16",
    stroke: "#9356F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsIconQuestionViolet);
export default __webpack_public_path__ + "static/media/alerts_icon_question_violet.cd2df1a8affb1b398280b226a57f0678.svg";
export { ForwardRef as ReactComponent };